import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../../context';
import fnolServices from '../../../services/fnolServices';

import {
  InputContainer,
  InputField,
  PrimaryButton,
  SecondaryButton,
} from '../../../components';

import { STEP_SEND_FNOL, STEP_UPLOAD_FILE } from '../../../CONSTANTS';
import ButtonWrapper from '../../../components/ButtonWrapper';

const ContactInformationForm = () => {
  const { customerInformation, fnolTemplate, setEmail, setStep, setTelephone } =
    useFnol();

  const { t } = useTranslation();

  const [state, setState] = useState({
    telephone: customerInformation.telephone,
    email: customerInformation.email,
    isFormValid: false,
  });

  const emailRegex = /\S+@\S+\.\S+/;

  useEffect(() => {
    setState((state) => ({
      ...state,
      telephone: customerInformation.telephone,
      email: customerInformation.email,
    }));
  }, []);

  useEffect(() => {
    if (state.telephone.trim().length < 5 || !emailRegex.test(state.email)) {
      setState((state) => ({
        ...state,
        isFormValid: false,
      }));

      return;
    }

    setState((state) => ({
      ...state,
      isFormValid: true,
    }));
  }, [state.email, state.telephone]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setEmail(state.email);
    setTelephone(state.telephone);
    setStep(STEP_SEND_FNOL);

    fnolServices.setCustomerEmail(fnolTemplate.fnolKey, state.email);
    fnolServices.setCustomerTelephoneNumber(
      fnolTemplate.fnolKey,
      state.telephone
    );
  };

  const handleGoBackClick = () => setStep(STEP_UPLOAD_FILE);

  return (
    <form onSubmit={handleSubmit}>
      <InputContainer>
        <label>{t('contactInformation.telephone.label')}</label>
        <InputField
          name='telephone'
          value={state.telephone}
          placeholder={t('contactInformation.telephone.placeholder')}
          onChange={handleChange}
        />
      </InputContainer>
      <InputContainer>
        <label>{t('contactInformation.email.label')}</label>
        <InputField
          type='email'
          name='email'
          value={state.email}
          placeholder={t('contactInformation.email.placeholder')}
          onChange={handleChange}
        />
      </InputContainer>
      <ButtonWrapper>
        <>
          <SecondaryButton onClick={handleGoBackClick}>
            {t('buttons.back')}
          </SecondaryButton>
          <PrimaryButton type='submit' disabled={!state.isFormValid}>
            {t('buttons.continue')}
          </PrimaryButton>
        </>
      </ButtonWrapper>
    </form>
  );
};

export default ContactInformationForm;
